document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('.product__accordion details');

  accordions.forEach((detail, index) => {
    // Öffne nur den ersten beim Laden
    if (index === 0) {
      detail.setAttribute('open', 'open');
    }

    detail.addEventListener('toggle', () => {
      if (detail.open) {
        accordions.forEach((other) => {
          if (other !== detail && other.tagName === 'DETAILS') {
            other.removeAttribute('open');
          }
        });
      }
    });
  });
});
